import { RolesEnums } from '@/store/enums/RolesEnums';

const app = {
  path: '/',
  redirect: '/top-up-balance',
  component: () => import('@/layout/Layout.vue'),
  meta: { roles: [RolesEnums.ALL] },
  children: [
    {
      path: '/top-up-balance',
      name: 'top-up-balance',
      meta: { roles: [RolesEnums.ALL] },
      component: () => import('@/views/pages/TopUpBalance.vue')
    }

  ]
};
export default app;
